import { useNavigate } from 'react-router-dom';

import { Box, Button, Stack, Text, Title } from '@mantine/core';

import { routes } from '@/routes';
import RestrictedAccessIcon from '@/assets/icons/RestrictedAccessIcon';
import { plum } from '@/styles/colors';

interface AccessRestrictedProps {
  title?: string;
  message?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  redirectRoute?: string;
}

const AccessRestricted = ({
  title = 'Access Restricted',
  message = "You don't have access to this patient profile as this doesn't belong to your clinic. Please reach out to Rhythm for more details.",
  buttonText = 'Go back to Dashboard',
  onButtonClick,
  redirectRoute
}: AccessRestrictedProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (redirectRoute) {
      navigate(redirectRoute);
    } else {
      navigate(routes.physician.dashboard);
    }
  };

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh'
      }}>
      <Stack align="center" gap="lg" maw={600} px="md">
        <RestrictedAccessIcon />

        <Title ta="center" fw={600} c={plum[9]} fs="32px" ff="Libre Caslon Text">
          {title}
        </Title>

        <Text fs="20px" ta="center" c={plum[9]} ff="Archivo">
          {message}
        </Text>

        <Button size="md" onClick={handleButtonClick}>
          {buttonText}
        </Button>
      </Stack>
    </Box>
  );
};

export default AccessRestricted;
